import React from 'react'

function Policies() {
  return (
    <div>Policies</div>
  )
}

export default Policies